import Image from 'components/LegacyImage'

const MobileHeroImage = ({ src, alt }: { src: string; alt: string }) => (
  <Image
    className='mc-corners--sm'
    src={src}
    alt={alt}
    width={198}
    height={282}
    objectFit='cover'
    objectPosition='center'
    layout='responsive'
  />
)

interface HeroDualImageTilesProps {
  img1Url: string
  img1Alt: string
  img2Url: string
  img2Alt: string
}

export const HeroDualImageTiles = ({
  img1Url,
  img1Alt,
  img2Url,
  img2Alt,
}: HeroDualImageTilesProps) => (
  <div className='d-flex justify-content-center mc-mb-9'>
    <div className='mc-mt-10 mc-mr-2 flex-grow-1' style={{ maxWidth: 250 }}>
      <MobileHeroImage src={img1Url} alt={img1Alt} />
    </div>
    <div className='flex-grow-1 mc-mt-2' style={{ maxWidth: 250 }}>
      <MobileHeroImage src={img2Url} alt={img2Alt} />
    </div>
  </div>
)
